<template>
  <div v-loading="loading" class="ec-line020-021-022">
    <el-breadcrumb v-show="!active" separator="/">
      <el-breadcrumb-item :to="{ path: $routePage.EC_LINE001 }"> {{ shopName }}</el-breadcrumb-item>
      <el-breadcrumb-item> {{ title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <h2 class="ec-line020-021-022__title" :class="active === 0 ? 'lg:mt-10 mt-5' : 'lg:mt-4 mt-1'">
      {{ title }}
    </h2>
    <div v-show="!active" class="ec-line020-021-022__banner" v-html="contentBanner"></div>
    <el-steps :active="active" align-center class="mt-5 mb-10">
      <el-step :title="$t('ec-lineQA.step.step1')"></el-step>
      <el-step :title="$t('ec-lineQA.step.step2')"></el-step>
      <el-step :title="$t('ec-lineQA.step.step3')"></el-step>
    </el-steps>
    <step-1 v-show="active == 0" v-model="form" @submit="onNextStep2"></step-1>
    <step-2 v-show="active == 1" :data="form" @submit="onNextStep3" @cancel="onBackStep1"></step-2>
    <step-3 v-show="active == 2"></step-3>
  </div>
</template>

<script>
import Step1 from '@/components/ec-line020-021-022/Step1.vue'
import Step2 from '@/components/ec-line020-021-022/Step2.vue'
import Step3 from '@/components/ec-line020-021-022/Step3.vue'
import { ContactService, HtmlService } from '@/services'
export default {
  components: { Step1, Step2, Step3 },
  data() {
    return {
      active: 0,
      form: {
        name_01: '',
        name_02: '',
        kana_01: '',
        kana_02: '',
        email: '',
        confirm_email: '',
        phone_number: '',
        inquiry_category_id: null,
        contents: '',
      },
      loading: false,
      contentBanner: '',
      listTitles: [this.$t('ec-line020.title'), this.$t('ec-line021.title'), this.$t('ec-line022.title')],
    }
  },
  computed: {
    inqueryCategory() {
      return this.$store.state.master.inquiryCategory
    },
    shopName() {
      return this.$store.getters['auth/getShopName']
    },
    title() {
      return this.listTitles[this.active]
    },
    meta() {
      return {
        description: [
          this.$t('ec-line020.description', { shop_name: this.shopName }),
          this.$t('ec-line021.description', { shop_name: this.shopName }),
          this.$t('ec-line022.description', { shop_name: this.shopName }),
        ][this.active],
        keywords: [
          this.$t('ec-line020.keyword', { shop_name: this.shopName }),
          this.$t('ec-line021.keyword', { shop_name: this.shopName }),
          this.$t('ec-line022.keyword', { shop_name: this.shopName }),
        ][this.active],
      }
    },
  },
  created() {
    this.form.inquiry_category_id = this.inqueryCategory[0].id

    this.fetchBannerInquiry()
  },
  methods: {
    async fetchBannerInquiry() {
      const res = await HtmlService.getHtmlContent(this.Constants.SHOP_CONFIG.BANNER_INQUIRY)
      this.contentBanner = res.data
    },
    onBackStep1() {
      this.active = 0
      this.$router.replace(this.$routePage.EC_LINE020)
    },
    onNextStep2() {
      this.active = 1
      this.$router.replace(this.$routePage.EC_LINE021)
    },
    onNextStep3() {
      this.loading = true

      ContactService.sendContact(this.form)
        .then(() => {
          this.active = 2
        })
        .then(() => this.$router.replace(this.$routePage.EC_LINE022))
        .catch((error) => this.handleError(error))
        .finally(() => (this.loading = false))
    },
  },

  metaInfo() {
    const { description, keywords } = this.meta
    return {
      title: this.title,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: description,
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: keywords,
        },
        {
          vmid: 'robots',
          name: 'robots',
          content: this.active === 0 ? '' : this.Constants.META_TAG.NO_INDEX_NO_FOLLOW,
        },
      ],
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/css/pages/ec-line020-021-022.scss';
</style>
